<template>
    <div id="AssetLocation">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                       <div class="page-title"> Used Truck List</div>
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <a href="javascript:void(0)" id="inventoryModalBtn" class="btn btn-primary pull-right" v-on:click="openModal()" ><i class="fp-import"></i>Load Inventory</a>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-inventory-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'assetInventoryList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'assetInventoryList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listAssetInventory"
                                    mode="remote"
                                    title="Asset Inventory"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        dropdownAllowAll: false,
                                    }"
                                    >
                                     <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template>
                                                    <router-link title="Upload Images" class="fp-edit" v-bind:to="{name: 'AssetInventoryUpdate',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div class="modal fade invoice-modal update-reading-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm basic-form-container">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require" for="name">File:</label><br/>
                                                    <input id="typeImage" type="file" @change="onFileChanged">
                                                    <span class="field-error">{{error}}</span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer btm-action-btn-fl">
                                        <button type="button" class="btn btn-tertiary" data-dismiss="modal"><i class="fp-close" > </i>Cancel</button>
                                        <button class="btn btn-primary" id="importFileBtn" v-on:click="importInventory()"><i class="fp-import" > </i>Import</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "AssetInventory",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Asset Inventory List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetLocationVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Action',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '# Stock',
                    field: 'stock_no',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'VIN',
                    field: 'vin',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "VIN", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Manufacturer',
                    field: 'manufacturer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Model',
                    field: 'model',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assigned Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Year',
                    field: 'year',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 10
            },
            loading:false,
            selectedFile:"",
            error:"",
            pageKey:"_asset_inventory_list_",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'asset_inventory') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },

        mounted: function() {
            var self = this;
            //self.loadList();

            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();


        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listAssetInventory.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            openModal: function(){
                var self = this;
                // $('#importFileBtn').text('Import');
                self.notFoundArr = [];
                self.selectedFile = "";
                self.error = "";
                self.notfound = false;
                $("#typeImage").val('');
                $('#myModal').modal('show');
            },
            onFileChanged (event) {
                const file = event.target.files[0]
                console.log(event.target);
                var self = this;
                self.selectedFile = file;
                self.notfound = false;
                self.notFoundArr = [];
                console.log(self.selectedFile);
            },

            loadList() {
                var self = this;

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/asset-inventory/details",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-inventory-list')

                    }
                });
            },

            importInventory: function(){
                var self = this;
                if(self.selectedFile == "" || self.selectedFile == null){
                    self.error = "Please Select Excel File.";
                    return;
                }else{
                    self.error = "";
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);
                formData.append('device', self.deviceType);

                self.loading = true;
                $('#importFileBtn').text('Fetching...');
                $('#importFileBtn').prop('disabled',true);
                $.ajax({
                url: process.env.ROOT_API + "/inventory/import",
                type: "POST",
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    $('#importFileBtn').text('Import');
                    $('#importFileBtn').prop('disabled',false);
                    self.loading = false;
                    if(data.code == 201){
                        self.error = data.message;
                        return;
                    }
                    if (data.status == "success") {
                        self.error = "";
                        $('#myModal').modal('hide');
                        self.loadList();

                    }
                },
                error: function (jqXHR, exception) {
                    $('#importFileBtn').text('Import');
                    $('#importFileBtn').prop('disabled',false);
                   self.loading = false;
                    $('#myModal').modal('hide');
                    self.generateStatusCodeMessage(jqXHR,true,'asset-inventory-import')
                }
            });
            },
        }
    };
</script>

<style scope>
/* #AssetLocation .vgt-wrap {
    float: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/asset/AssetInventoryListing.vue